<template>
  <div>
      <v-dialog v-model="dialog" width="564px" class="odaberite-spis-wrapper">
      <v-card class="universal-vcard">
        <div id="preseli-main-upload" class="universal-vdialog-title v-dialog-title-handler">
          {{ title_text }}
        </div>

        <v-text-field
          class="universal-vdialog-textfield"
          type="text"
          :label="$t('components.file_management.folderSelect.searchPlaceholder')"
          v-model="search_txt"
        ></v-text-field>

        <div class="modal-drop-wrapp">
          <CustomDropdown
            :id="'drop_clanovi'"
            :additional_classes="['phase']"
            v-model="selected_group_id"
            :drop_items="dropp_elements"
            :init_text="
              results.length > 0
                ? $t('components.file_management.folderSelect.selectCase')
                : $t('components.file_management.folderSelect.noCases')
            "
          />
          <div
            class="clear-filters"
            v-if="selected_group"
            @click="clearEverything()"
          >
            {{ $t('components.file_management.folderSelect.clearSelection') }}
          </div>
        </div>
        <folder-filter-tags :filter="available_folders" @changedValue="(val)=> selected_folder_filter = val"/>
        <div
          class="folder-select-wrapp"
          v-if="all_folders.length > 0 && !loading"
        >
          <div v-for="(sp, key) in all_folders" :key="key">
            <tree-folders
              :depth="0"
              :item="sp"
              :accessToken="accessToken"
              @node-click="setSpisFolder"
              :smjer="true"
            ></tree-folders>
          </div>
        </div>
        <div v-else class="empty-folders-not-selected">
          <span v-if="!loading">{{ $t('components.file_management.folderSelect.noCaseSelected') }}</span>
        </div>
        <div v-if="loading">
          <svg class="dot-spin" viewBox="0 0 50 50">
            <circle
              class="path"
              cx="25"
              cy="25"
              r="20"
              fill="none"
              stroke-width="5"
            ></circle>
          </svg>
        </div>

        <div class="vdialog-buttons-wrapper wrapper-three-buttons">
          <div
            class="universal-vdialog-button vbutton-secondary"
            text
            @click="dialog = false"
          >
            {{ $t('components.file_management.folderSelect.cancel') }}
          </div>
          <div
             v-if="selected_group_id && selected_folder"
            class="universal-vdialog-button vbutton-primary"
            text
            :disabled="!is_valid"
            @click="emitSelectionToParrent()"
          >
            {{ $t('components.file_management.folderSelect.confirmSelection') }}
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import graph from "@/services/graph.js";
import predmet_caller from "../../apiCallers/promise_handler_db/predmeti";
import TreeFolders from "@/components/generalComponents/TreeFolders.vue";
import CustomDropdown from "@/components/generalComponents/CustomDropdown.vue";
import $ from "jquery";
import { DEFAULT_CASE_FOLDERS } from '../../helpers/default_vals/enums';
import FolderFilterTags from './FolderFilterTags.vue';
import { canConvertFileToPDF } from '../../helpers/file';

export default {
  components: {
    TreeFolders,
    CustomDropdown,
    FolderFilterTags,
  },
  props:{
    main_id :{
      type : String,
      default : "move-style"
    }
  },
  data() {
    return {
      search_txt: "",
      dialog: false,
      title_text: "",
      init_title_text: "",
      results: [],
      timeout: null,
      selected_group: null,
      all_folders: [],
      folder_id: null, // Assuming you pass this value when a root is selected,
      accessToken: null,
      selected_group_id: null,
      dropp_elements: [],
      empty_drop_elem: { id: 0, naziv: "" },
      loading: false,
      selected_folder: null,

      selected_folder_filter : DEFAULT_CASE_FOLDERS[0],
      available_folders : 0
    };
  },
  computed: {
    is_valid: function () {
      return this.selected_group && this.selected_folder;
    }
  },
  methods: {
    open(af_def = 0)
    {
      this.available_folders = af_def;
      this.dialog = true;
    },
    
    emitSelectionToParrent(){
      this.$emit("folderSelected",{case_id : this.selected_group_id, selected_folder : this.selected_folder})
      this.dialog = false;
    },

    clearEverything() {
      clearTimeout(this.timeout);
      this.selected_group = null;
      this.selected_group_id = null;
    },
    preseliStyling() {
      setTimeout(function () {
        // var upl = document.getElementById("preseli-main-upload");
        let upl = document.getElementsByClassName("v-dialog-title-handler")
        for(let i = 0; i< upl.length; i++)
        {
          let tmp_elem = upl[i];
          $(tmp_elem.parentElement.parentElement).addClass(
          "file-upload-dialog-wrapper"
        );
        $(tmp_elem.parentElement).addClass("main-file-upload-wrapper");
        }
        // console.log("upl", upl)
        
        $(".spis-megawrapper").removeClass("active");
        $(".main-file-upload-wrapper").find(".spis-megawrapper:first").click();
      }, 100);
    },
    setSpisFolder(selected_folder) {
      console.log("selected folder", selected_folder);
      this.selected_folder = selected_folder;
    },
    // Fetch the root folder
    async getRootFolder(id) {
      let folder = await graph.getSingleFile(this.selected_group.group_url, id);
      return {
        item: folder,
        children: [],
      };
    },

    // Fetch child folders recursively (without files)
    async fetchChildFolders(id) {
      let children = [];
      const response = await graph.getFileChildren(
        this.selected_group.group_url,
        id
      );

      if (response.value && response.value.length > 0) {
        // Filter only folders and process recursively
        for (let item of response.value) {
          if (item.folder) {
            let folderItem = {
              item: item,
              children: await this.fetchChildFolders(item.id), // Recursive call for subfolders
            };
            children.push(folderItem);
          }
        }
      }
      return children;
    },

    listActiveByFilterFolders()
    {
      let folders = [];
      switch(this.selected_folder_filter.name){
        case("spisi"):
          folders = folders.concat(this.selected_group.spis.map((p) => p.id_spis));
          break;
        case("radni"):
          folders.push(this.selected_group.root_radni, this.selected_group.root_popratni);
        break;
        case("komunikacija"):
          folders.push(
          this.selected_group.root_ulazna,
          this.selected_group.root_izlazna
        );
        break;
      }
      return folders
    },

    // Core function to get the folder structure
    async getFolderStructure() {
      console.time("FetchData");
      this.loading = true;
      // Create a list of folder IDs to fetch
      let all_folders_structure = this.listActiveByFilterFolders()

      // Fetch all root folders in parallel using Promise.all
      const rootFoldersPromises = all_folders_structure.map((folderId) =>
        this.getRootFolder(folderId)
      );
      const rootFolders = await Promise.all(rootFoldersPromises);

      // Fetch all child folders for each root folder in parallel
      const childFoldersPromises = all_folders_structure.map((folderId) =>
        this.fetchChildFolders(folderId)
      );
      const childFolders = await Promise.all(childFoldersPromises);

      // Combine root folders and their corresponding children
      this.all_folders = rootFolders.map((folder, index) => ({
        ...folder,
        children: childFolders[index],
      }));

      console.timeEnd("FetchData");

      console.log(this.all_folders);
      this.loading = false;

      this.preseliStyling();
    },

    // Mock search function
    async text_change_search() {
      // Replace this with your actual search logic for results

      if(this.search_txt.trim().length > 0)
      {
        await predmet_caller.searchPredmeti(this.search_txt).then((resp) => {
          console.log(resp.data.res_predmeti);
          this.results = resp.data.res_predmeti;
          if(this.results.length>0)
          {

            this.dropp_elements = this.results.map((p) => {
            return {
              id: p.group_url,
              naziv: p.broj_predmeta,
            };


          });
          this.selected_group_id = this.dropp_elements[0].id

          }
        
        });
      }
     
    },

    updateSelectedGroupTitle() {
      if (this.selected_group != null) {
        this.title_text =
          this.$t('components.file_management.folderSelect.storageTitle') +
          " - " + this.$t('components.file_management.folderSelect.case') + ": " +
          this.selected_group.broj_predmeta;
      } else {
        this.title_text = this.init_title_text;
      }
    }
  },
  async created() {
    this.accessToken = this.$store.state.aToken;
    this.search_txt = this.$store.state.logged_in_user.case_activity[0].predmet.broj_predmeta;
    
    // Initialize text with translations
    this.title_text = this.$t('components.file_management.folderSelect.title');
    this.init_title_text = this.$t('components.file_management.folderSelect.title');
    this.empty_drop_elem = { id: 0, naziv: this.$t('components.file_management.folderSelect.selectCase') };
  },
  watch: {
    dialog() {
      if (this.selected_group) {
        this.loading = true;
        this.getFolderStructure();
      }
    },
    selected_folder_filter(){
      if(this.selected_group_id)
      {
        this.getFolderStructure();
      }
    },
    selected_group_id() {
      this.loading = true;
      if (this.selected_group_id && this.selected_group_id != 0) {
        console.log(
          this.results.find((p) => p.group_url == this.selected_group_id)
        );
        this.selected_group = this.results.find(
          (p) => p.group_url == this.selected_group_id
        );
        this.updateSelectedGroupTitle();
        if (this.selected_group != null) {
          this.getFolderStructure(); // Fetch folder structure when group is selected
        } else {
          this.loading = false;
        }
      } else {
        this.title_text = this.init_title_text;
        this.all_folders = [];
        this.selected_group = null;
        this.loading = false;
      }
    },
    search_txt() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if (this.search_txt.trim()) {
          this.text_change_search();
        }
      }, 500);
    },
  },
};
</script>